import { FC, useEffect, useState } from "react";
import { useLoading } from "../../context/LoadingProvider/useLoading";
import { ActionButtonEnum } from "../../enums/actionButtonEnum";
import useActionButtons from "../../hooks/useActionButtons";
import { Output } from "../../services/types";
import { isString } from "../../utils/stringUtils";
import Button from "../UI/Button";
import SelectInput from "../UI/SelectInput";
import { ISelectOption } from "../UI/SelectInput/types";
import DefaultFormParserLayout from "./default-form-parser-layout";
import { Space } from "antd";

export type SelectAndActionsLayoutProps = {
  options: ISelectOption[];
  actions: ActionButtonEnum[];
  selectLabel?: string;
  onRefresh: (selected: string, output: Output) => Promise<string>;
};

const SelectAndActionsLayout: FC<SelectAndActionsLayoutProps> = ({
  options,
  selectLabel,
  actions,
  onRefresh,
}) => {
  const loading = useLoading();

  const [report, setReport] = useState<string>("");
  const [selected, setSelected] = useState<string>((options === null || options.length === 0) ? "" : `${options[0].value}`);
  const validSearch = selected !== "";

  const {
    isToShowRefreshAction,
    isToShowSaveCSVAction,
    isToShowSavePDFAction,
  } = useActionButtons(actions);

  const refreshReport = async (output: Output = Output.HTML) => {
    loading.addLoading();

    const res = await onRefresh(selected, output);

    if (Output.isHTML(output) && isString(res)) {
      setReport(res);
    }

    loading.removeLoading();
  };

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="middle" wrap align="center">
        <SelectInput
          label={selectLabel}
          autoFocus
          options={options}
          onSelectChange={(e) => setSelected(e?.value ? e.value : e)}
          value={selected}
          width={400}
        />

        {isToShowRefreshAction && (
          <Button
            onClick={() => refreshReport()}
            type="primary"
            disabled={!validSearch}
          >
            Refresh
          </Button>
        )}

        {isToShowSaveCSVAction && (
          <Button
            type="primary"
            disabled={!validSearch}
            onClick={() => refreshReport(Output.CSV)}
          >
            Save as CSV
          </Button>
        )}

        {isToShowSavePDFAction && (
          <Button
            type="primary"
            disabled={!validSearch}
            onClick={() => refreshReport(Output.PDF)}
          >
            Save as PDF
          </Button>
        )}
      </Space>
    </DefaultFormParserLayout>
  );
};

export default SelectAndActionsLayout;
